import {createContext, use} from 'react'

import type {CommitsLayoutPayload} from '../routes/commits-layout-route'

export const CommitsLayoutPayloadContext = createContext<CommitsLayoutPayload>({
  helpUrl: '',
})

export function useCommitsLayoutPayload(): CommitsLayoutPayload {
  return use(CommitsLayoutPayloadContext)
}
